import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer barraColores row p-0 m-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col barraColor1" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col barraColor2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col barraColor3" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}